import { useAcceptOrgInvitation, useDeclineOrgInvitation } from '../JoinOrganization/hooks';
import { OrgInvitationCard } from './OrgInvitationCard';

export const OrgInvitation: React.FC<{ invitation: CF.API.Organizations.OrgMemberInvite }> = ({ invitation }) => {
  const handleAcceptInvitation = useAcceptOrgInvitation();
  const handleDeclineInvitation = useDeclineOrgInvitation();

  return (
    <OrgInvitationCard
      invitation={invitation}
      acceptInvitation={handleAcceptInvitation}
      declineInvitation={handleDeclineInvitation}
      data-testid={`org-invitation-${invitation.id}`}
    />
  );
};
